import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  AlignSelfProps,
  BackgroundProps,
  BorderColorProps,
  BorderProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  BoxShadowProps,
  DisplayProps,
  FlexBasisProps,
  FlexDirectionProps,
  FlexWrapProps,
  FontSizeProps,
  GridAreaProps,
  HeightProps,
  JustifyContentProps,
  MaxWidthProps,
  MinHeightProps,
  MinWidthProps,
  OrderProps,
  OverflowProps,
  PositionProps,
  SpaceProps,
  FlexProps as StyledFlexProps,
  TextAlignProps,
  WidthProps,
  ZIndexProps,
} from 'styled-system';
import {
  alignItems,
  alignSelf,
  background,
  backgroundColor,
  border,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  boxShadow,
  color,
  compose,
  display,
  flex,
  flexBasis,
  flexDirection,
  flexWrap,
  fontSize,
  gridArea,
  height,
  justifyContent,
  maxWidth,
  minHeight,
  minWidth,
  order,
  overflow,
  position,
  space,
  textAlign,
  width,
  zIndex,
} from 'styled-system';

import type { BackgroundColorProps, ColumnGapProps, RowGapProps } from '../theme/system-types';
import type {
  AsProps,
  BoxSizingProps,
  FlexGapProps,
  FlexGrowProps,
  FlexShrinkProps,
  ThemeTopProps,
} from '../theme/system-utilities';
import {
  boxSizing,
  flexColumnGap,
  flexGap,
  flexGrow,
  flexRowGap,
  flexShrink,
  themeTop,
} from '../theme/system-utilities';

export interface FlexProps
  extends
    PositionProps,
    WidthProps,
    HeightProps,
    MinWidthProps,
    MaxWidthProps,
    MinHeightProps,
    FlexDirectionProps,
    FlexBasisProps,
    FlexGrowProps,
    FlexShrinkProps,
    FlexWrapProps,
    FlexGapProps,
    ColumnGapProps,
    RowGapProps,
    StyledFlexProps,
    SpaceProps,
    JustifyContentProps,
    AlignItemsProps,
    FontSizeProps,
    AlignSelfProps,
    TextAlignProps,
    BoxSizingProps,
    BoxShadowProps,
    BorderProps,
    BorderWidthProps,
    BorderColorProps,
    BorderStyleProps,
    BorderRadiusProps,
    BackgroundProps,
    BackgroundColorProps,
    OverflowProps,
    GridAreaProps,
    ThemeTopProps,
    ZIndexProps,
    AsProps {}

export const Flex = styled.div<FlexProps>(
  { display: 'flex' },
  compose(
    position,
    width,
    height,
    maxWidth,
    minWidth,
    minHeight,
    flexDirection,
    flexBasis,
    flexWrap,
    flexGrow as any,
    flexShrink as any,
    flexGap,
    flexColumnGap,
    flexRowGap,
    flex,
    space,
    justifyContent,
    alignItems,
    fontSize,
    alignSelf,
    textAlign,
    boxSizing as any,
    boxShadow,
    border,
    borderWidth,
    borderColor,
    borderStyle,
    borderRadius,
    background,
    backgroundColor,
    color,
    overflow,
    gridArea,
    themeTop as any,
    zIndex
  )
);

export const FlexItem = styled.div<
  FlexProps &
    FlexGrowProps &
    FlexShrinkProps &
    FlexBasisProps &
    OrderProps &
    AlignSelfProps &
    DisplayProps &
    WidthProps &
    MaxWidthProps &
    SpaceProps
>(
  compose(
    flex,
    flexGrow as any,
    flexShrink as any,
    flexBasis,
    order,
    alignSelf,
    display,
    width,
    maxWidth,
    space
  )
);
